import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { take } from 'rxjs';
import { LoginFormComponent } from 'src/app/shared/components/login-form/login-form.component';
import { LoginFormGroupType } from 'src/app/shared/components/login-form/models/login-form';
import { CurrentFacilityService } from 'src/app/shared/services';

@Component({
    selector: 'app-sprintpay-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class SignInComponent implements OnInit {
    public loginForm: LoginFormGroupType;
    public isEnabledLogin: boolean;
    public urlAdministrativeLogin: string;
    public hide = true;
    public hideTitle = false;
    @Input() widthLogo = '180';
    @Input() heightLogo = '131';

    @ViewChild(LoginFormComponent) loginFormComponent: LoginFormComponent;

    @Input() sourceSignUp: string = 'sprintpay';

    constructor(
        private route: ActivatedRoute,
        private currentFacilityService: CurrentFacilityService
    ) {}

    ngOnInit(): void {
        this.urlAdministrativeLogin = this.currentFacilityService.getUrlAdministrative();
        this.subscribeRoute();
    }

    subscribeRoute(): void {
        this.route.data.pipe(take(1)).subscribe((data: Data) => (this.hideTitle = !!data['hideTitle']));
    }
}
